// ── Changelog ─────────────────────────────────────────────
export const changelogApi = {
  list: (limit = 100) => api.get('/changelog', { params: { limit } }),
};
import api from './axios.js';

// ── Ankündigungen ───────────────────────────────────────────
export const announcementsApi = {
  getActive: () => api.get('/announcements/active'),
};

// ── Authentifizierung ───────────────────────────────────────
export const authApi = {
  exchangeImpersonationTicket: (ticket)             => api.post('/auth/impersonation/exchange', { ticket }),
  forgotPassword:              (email, slug)        => api.post('/auth/forgot-password', { email, slug }),
  resetPassword:               (token, newPassword) => api.post('/auth/reset-password', { token, newPassword }),
  updatePreferences:           (patch)              => api.patch('/auth/preferences', patch),
  markTourSeen:                (key)                => api.post(`/auth/tours/${encodeURIComponent(key)}/seen`),
};

// ── Dokumente ────────────────────────────────────────────────
export const documentsApi = {
  list:                      (params = {})                     => api.get('/documents', { params }),
  get:                       (id)                              => api.get(`/documents/${id}`),
  create:                    (data)                            => api.post('/documents', data),
  update:                    (id, data)                        => api.put(`/documents/${id}`, data),
  similarOffers:             (topic, currentLineItems = [])    => api.get('/documents/offers/similar', {
    params: {
      topic,
      current_line_items: JSON.stringify(currentLineItems),
    },
  }),
  importOfferCsv:            (csv, options = {}, mapping = {}) => api.post('/documents/import/csv/offer-lines', { csv, options, mapping }),
  delete:                    (id)                              => api.delete(`/documents/${id}`),
  updateStatus:              (id, status, extra = {})          => api.patch(`/documents/${id}/status`, { status, ...extra }),
  convert:                   (id)                              => api.post(`/documents/${id}/convert`),
  createCreditNote:          (id)                              => api.post(`/documents/${id}/credit-note`),
  dashboard:                 ()                                => api.get('/documents/stats/dashboard'),
  getProjectMaterials:       (projectId)                       => api.get(`/documents/project/${projectId}/materials`),
  getProjectMaterialCatalog: (projectId)                       => api.get(`/documents/project/${projectId}/material-catalog`),
  getProjectInvoices:        (projectId)                       => api.get(`/documents/project/${projectId}/invoices`),
  getProjectBilling:         (projectId)   => api.get(`/documents/project/${projectId}/billing`),
  getProjectAssets:          (projectId)   => api.get(`/documents/project/${projectId}/assets`),
};

// ── Sperrobjekte (pessimistisches Locking) ────────────────────
export const locksApi = {
  acquire: (entityType, entityId) => api.post(`/locks/${entityType}/${entityId}`),
  release: (entityType, entityId) => api.delete(`/locks/${entityType}/${entityId}`),
  status:  (entityType, entityId) => api.get(`/locks/${entityType}/${entityId}`),
};

export const carpentryApi = {
  listTemplates:  ()         => api.get('/carpentry/templates'),
  getTemplate:    (id)       => api.get(`/carpentry/templates/${id}`),
  createTemplate: (data)     => api.post('/carpentry/templates', data),
  updateTemplate: (id, data) => api.put(`/carpentry/templates/${id}`, data),
  deleteTemplate: (id)       => api.delete(`/carpentry/templates/${id}`),
};

// ── Kunden ───────────────────────────────────────────────────
export const customersApi = {
  list:          ()              => api.get('/customers'),
  get:           (id)            => api.get(`/customers/${id}`),
  create:        (data)          => api.post('/customers', data),
  update:        (id, data)      => api.put(`/customers/${id}`, data),
  delete:        (id)            => api.delete(`/customers/${id}`),
  // Kontakte
  getContacts:   (id)            => api.get(`/customers/${id}/contacts`),
  createContact: (id, data)      => api.post(`/customers/${id}/contacts`, data),
  updateContact: (id, cid, data) => api.put(`/customers/${id}/contacts/${cid}`, data),
  deleteContact: (id, cid)       => api.delete(`/customers/${id}/contacts/${cid}`),
};

// ── Fahrzeuge ───────────────────────────────────────────────────
export const vehiclesApi = {
  list:              ()         => api.get('/vehicles'),
  get:               (id)       => api.get(`/vehicles/${id}`),
  create:            (data)     => api.post('/vehicles', data),
  update:            (id, data) => api.put(`/vehicles/${id}`, data),
  delete:            (id)       => api.delete(`/vehicles/${id}`),
  getAssignments:          (id)        => api.get(`/vehicle-assignments/${id}`),
  getAssignmentsByProject: (projectId) => api.get(`/vehicle-assignments/project/${projectId}`),
  createAssignment: (data) => api.post('/vehicle-assignments', data),
  deleteAssignment:        (id)        => api.delete(`/vehicle-assignments/${id}`),
  getCosts:          (id)       => api.get(`/vehicle-costs/${id}`),
  createCost:        (data)     => api.post('/vehicle-costs', data),
  updateCost:        (id, data) => api.put(`/vehicle-costs/${id}`, data),
  deleteCost:        (id)       => api.delete(`/vehicle-costs/${id}`),
  getMaintenance:    (id)       => api.get(`/vehicle-maintenance/${id}`),
  createMaintenance: (data)     => api.post('/vehicle-maintenance', data),
  updateMaintenance: (id, data) => api.put(`/vehicle-maintenance/${id}`, data),
  deleteMaintenance: (id)       => api.delete(`/vehicle-maintenance/${id}`),
  getDocuments:      (id)       => api.get(`/vehicle-documents/${id}`),
  createDocument:    (data)     => api.post('/vehicle-documents', data),
  deleteDocument:    (id)       => api.delete(`/vehicle-documents/${id}`),
};

// ── Maschinen ────────────────────────────────────────────────────
export const machinesApi = {
  list:              ()         => api.get('/machines'),
  get:               (id)       => api.get(`/machines/${id}`),
  create:            (data)     => api.post('/machines', data),
  update:            (id, data) => api.put(`/machines/${id}`, data),
  delete:            (id)       => api.delete(`/machines/${id}`),
  getAssignments:          (id)        => api.get(`/machine-assignments/${id}`),
  getAssignmentsByProject: (projectId) => api.get(`/machine-assignments/project/${projectId}`),
  createAssignment: (data) => api.post('/machine-assignments', data),
  deleteAssignment:        (id)        => api.delete(`/machine-assignments/${id}`),
  getCosts:          (id)       => api.get(`/machine-costs/${id}`),
  createCost:        (data)     => api.post('/machine-costs', data),
  updateCost:        (id, data) => api.put(`/machine-costs/${id}`, data),
  deleteCost:        (id)       => api.delete(`/machine-costs/${id}`),
  getMaintenance:    (id)       => api.get(`/machine-maintenance/${id}`),
  createMaintenance: (data)     => api.post('/machine-maintenance', data),
  updateMaintenance: (id, data) => api.put(`/machine-maintenance/${id}`, data),
  deleteMaintenance: (id)       => api.delete(`/machine-maintenance/${id}`),
  getDocuments:      (id)       => api.get(`/machine-documents/${id}`),
  createDocument:    (data)     => api.post('/machine-documents', data),
  deleteDocument:    (id)       => api.delete(`/machine-documents/${id}`),
};

// ── Asset-Nutzung (Fahrzeuge + Maschinen) ────────────────────────
export const assetUsageApi = {
  get:    (assetId) => api.get(`/asset-usage/${assetId}`),
  create: (data)    => api.post('/asset-usage', data),
  delete: (id)      => api.delete(`/asset-usage/${id}`),
};

// ── Projekte ─────────────────────────────────────────────────
export const projectsApi = {
  list:                  (params = {})    => api.get('/projects', { params }),
  dropdown:              ()               => api.get('/projects/dropdown'),
  get:                   (id)             => api.get(`/projects/${id}`),
  create:                (data)           => api.post('/projects', data),
  update:                (id, data)       => api.put(`/projects/${id}`, data),
  delete:                (id)             => api.delete(`/projects/${id}`),
  getMaterials:          (id)             => api.get(`/projects/${id}/materials`),
  getHours:              (id)             => api.get(`/projects/${id}/hours`),
  getMaterialMovements:  (id)             => api.get(`/projects/${id}/material-movements`),
  deleteProjectMovement: (id, movId)      => api.delete(`/projects/${id}/material-movements/${movId}`),
  partialReturnMat:      (id, movId, qty) => api.patch(`/projects/${id}/material-movements/${movId}`, { quantity_to_remove: qty }),
  getTimestamps:         (id, params = {}) => api.get(`/projects/${id}/timestamps`, { params }),
  rapportPdf:            (id, params = {}) => api.get(`/projects/${id}/rapport-pdf`, { params, responseType: 'blob' }),
  unlinkTimestamp:       (id, tsId)       => api.patch(`/projects/${id}/timestamps/${tsId}/unlink`),
  partialUnlinkTs:       (id, tsId, hrs)  => api.patch(`/projects/${id}/timestamps/${tsId}/partial-unlink`, { hours_to_remove: hrs }),
  getRemaining:          (id)             => api.get(`/projects/${id}/remaining`),
  // Phasen
  getPhases:             (id)             => api.get(`/projects/${id}/phases`),
  createPhase:           (id, data)       => api.post(`/projects/${id}/phases`, data),
  updatePhase:           (id, phId, data) => api.put(`/projects/${id}/phases/${phId}`, data),
  deletePhase:           (id, phId)       => api.delete(`/projects/${id}/phases/${phId}`),
  // Mitglieder
  addMember:             (id, data)       => api.post(`/projects/${id}/members`, data),
  removeMember:          (id, userId)     => api.delete(`/projects/${id}/members/${userId}`),
};

// ── Baustellenplanung ────────────────────────────────────────
export const scheduleApi = {
  list:     (params = {}) => api.get('/schedule', { params }),
  create:   (data)        => api.post('/schedule', data),
  update:   (id, data)    => api.put(`/schedule/${id}`, data),
  delete:   (id)          => api.delete(`/schedule/${id}`),
  userList: ()            => api.get('/schedule/users/list'),
};

// ── Material / Lager ─────────────────────────────────────────
export const materialApi = {
  list:                 (params = {}) => api.get('/material', { params }),
  stats:                ()            => api.get('/material/stats'),
  demandCheck:          ()            => api.get('/material/demand-check'),
  get:                  (id)          => api.get(`/material/${id}`),
  create:               (data)        => api.post('/material', data),
  update:               (id, data)    => api.put(`/material/${id}`, data),
  delete:               (id)          => api.delete(`/material/${id}`),
  bulkDeleteDeletable:  (params = {}) => api.delete('/material/bulk/deletable', { params }),
  bulkDeleteBySupplier: (supplierId)  => api.delete(`/material/bulk/by-supplier/${supplierId}`),
  addMovement:          (id, data)    => api.post(`/material/${id}/movement`, data),
  importCsv:            (data)        => api.post('/material/import/csv', data, { timeout: 60000 }),
  importDatanorm:       (formData)    => api.post('/material/import/datanorm', formData, {
    timeout: 300000,
    headers: { 'Content-Type': 'multipart/form-data' },
  }),
  projects:    ()            => api.get('/material/projects'),
  inventory:   (data)        => api.post('/material/inventory', data),
  qrLabel:      (id)         => api.get(`/material/${id}/qr-label`, { responseType: 'blob' }),
  qrLabelsBulk: (ids)        => api.post('/material/qr-labels', { ids }, { responseType: 'blob' }),
};

// ── Lieferanten ──────────────────────────────────────────────
export const supplierApi = {
  list:   ()         => api.get('/supplier'),
  get:    (id)       => api.get(`/supplier/${id}`),
  create: (data)     => api.post('/supplier', data),
  update: (id, data) => api.put(`/supplier/${id}`, data),
  delete: (id)       => api.delete(`/supplier/${id}`),
};

// ── Stammdaten-Import ────────────────────────────────────────
export const importApi = {
  getEntities:   ()               => api.get('/import/entities'),
  getFields:     (entity)         => api.get(`/import/entities/${entity}/fields`),
  analyze:       (formData)       => api.post('/import/analyze', formData, {
    timeout: 60000,
    headers: { 'Content-Type': 'multipart/form-data' },
  }),
  preview:       (payload)        => api.post('/import/preview', payload, { timeout: 60000 }),
  commit:        (payload)        => api.post('/import/commit', payload, { timeout: 120000 }),
  undo:          (logId)          => api.post(`/import/${logId}/undo`),
  getHistory:    (params = {})    => api.get('/import/log', { params }),
  getTemplates:  (entity)         => api.get('/import/templates', { params: { entity } }),
  saveTemplate:  (payload)        => api.post('/import/templates', payload),
};

// ── Permissions ─────────────────────────────────────────────
export const permissionsApi = {
  list:       ()             => api.get('/permissions'),
  getForUser: (userId)       => api.get(`/permissions/user/${userId}`),
  setForUser: (userId, data) => api.put(`/permissions/user/${userId}`, data),
};

// ── Dashboard ────────────────────────────────────────────────
export const settingsApi = {
  get:      ()     => api.get('/settings/public'),
  getFull:  ()     => api.get('/settings'),
  save:     (data) => api.put('/settings', data),
  holidays: (year) => api.get('/settings/holidays', { params: { year } }),
};

export const payrollApi = {
  get:    (month)        => api.get('/payroll', { params: { month } }),
  save:   (userId, data) => api.put(`/payroll/${userId}`, data),
};

export const pendingApi = {
  counts: () => api.get('/pending-counts'),
};

// ── GAEB DA XML ──────────────────────────────────────────────
export const gaebApi = {
  import:       (xml)          => api.post('/gaeb/import', { xml }),
  exportUrl:    (docId, phase) => `/api/gaeb/export/${docId}/${phase}?token=${encodeURIComponent(localStorage.getItem('token') || '')}`,
};

// ── IDS Connect (OCI Punchout) ───────────────────────────────
export const idsConnectApi = {
  getSuppliers:   ()           => api.get('/ids-connect/suppliers'),
  createSupplier: (data)       => api.post('/ids-connect/suppliers', data),
  updateSupplier: (id, data)   => api.put(`/ids-connect/suppliers/${id}`, data),
  deleteSupplier: (id)         => api.delete(`/ids-connect/suppliers/${id}`),
  createSession:  (supplierId) => api.post('/ids-connect/session', { supplier_id: supplierId }),
};

export const dashboardApi = {
  get: () => api.get('/dashboard'),
};

// ── Zeiterfassung ─────────────────────────────────────────────
export const timestampApi = {
  list:             (params = {}) => api.get('/timestamp', { params }),
  materials:        (params = {}) => api.get('/timestamp/materials', { params }),
  create:           (data)        => api.post('/timestamp', data),
  update:           (id, data)    => api.put(`/timestamp/${id}`, data),
  rebook:           (id, projectId) => api.patch(`/timestamp/${id}/rebook`, { project_id: projectId }),
  delete:           (id)          => api.delete(`/timestamp/${id}`),
  approve:          (id)          => api.patch(`/timestamp/${id}/approve`),
  reject:           (id, note)    => api.patch(`/timestamp/${id}/reject`, { rejection_note: note }),
  pending:          (params = {}) => api.get('/timestamp/pending', { params }),
  materialsPending: (params = {}) => api.get('/timestamp/materials/pending', { params }),
  approveMaterial:  (id)          => api.patch(`/timestamp/materials/${id}/approve`),
  rejectMaterial:   (id, note)    => api.patch(`/timestamp/materials/${id}/reject`, { rejection_note: note }),
  report:           (params = {}) => api.get('/timestamp/report', { params }),
  export:           (params = {}) => api.get('/timestamp/export', { params }),
  regiePdf:         (id)          => api.get(`/timestamp/${id}/regie-pdf`, { responseType: 'blob' }),
  foremanProjects:  ()            => api.get('/timestamp/foreman-projects'),
  daySummary:       (params)      => api.get('/timestamp/day-summary', { params }),
  signDaySummary:   (data)        => api.post('/timestamp/day-summary/sign', data),
};

export const employeeApi = {
  list:   ()         => api.get('/employee'),
  create: (data)     => api.post('/employee', data),
  update: (id, data) => api.put(`/employee/${id}`, data),
  delete: (id, reduceSubscription = true) => api.delete(`/employee/${id}`, { params: { reduce_subscription: reduceSubscription } }),
  bulk:   (data)     => api.patch('/employee/bulk', data),
};

export const subscriptionApi = {
  upgrade: () => api.post('/subscription/upgrade'),
  sync:    () => api.get('/subscription/sync'),
};

export const sickLeaveApi = {
  list:        (params = {}) => api.get('/sick-leave', { params }),
  stats:       (params = {}) => api.get('/sick-leave/stats', { params }),
  create:      (data)        => api.post('/sick-leave', data),
  setAttest:   (id, data)    => api.patch(`/sick-leave/${id}/attest`, data),
  acknowledge: (id)          => api.patch(`/sick-leave/${id}/acknowledge`),  
  delete:      (id)          => api.delete(`/sick-leave/${id}`),
};

export const vacationApi = {
  getAccount:       (year)         => api.get('/vacation/account', { params: { year } }),
  getAccounts:      (year)         => api.get('/vacation/accounts', { params: { year } }),
  updateAccount:    (userId, data) => api.put(`/vacation/account/${userId}`, data),
  getRequests:      ()             => api.get('/vacation/requests'),
  createRequest:    (data)         => api.post('/vacation/requests', data),
  reviewRequest:    (id, data)     => api.put(`/vacation/requests/${id}/review`, data),
  deleteRequest:    (id)           => api.delete(`/vacation/requests/${id}`),
  sickRebook:       (id, data)     => api.post(`/vacation/requests/${id}/sick-rebook`, data),
  reviewSickRebook: (id, data)     => api.put(`/vacation/requests/${id}/sick-rebook/review`, data),
};

// ── PDF ──────────────────────────────────────────────────────
function getPdfApiBase() {
  const stored = localStorage.getItem('apiBaseUrl') || '';
  return stored.replace(/\/+$/, '') || '/api';
}

export function getAufmassPdfUrl(id) {
  const token = localStorage.getItem('token') || '';
  const locale = localStorage.getItem('locale') || 'de';
  return `${getPdfApiBase()}/aufmass/${id}/pdf?token=${encodeURIComponent(token)}&lang=${encodeURIComponent(locale)}`;
}

export function getPdfUrl(id) {
  const token = localStorage.getItem('token') || '';
  const locale = localStorage.getItem('locale') || 'de';
  return `${getPdfApiBase()}/pdf/${id}?token=${encodeURIComponent(token)}&lang=${encodeURIComponent(locale)}`;
}

export function getZugferdUrl(id) {
  const token = localStorage.getItem('token') || '';
  const locale = localStorage.getItem('locale') || 'de';
  return `${getPdfApiBase()}/pdf/${id}/zugferd?token=${encodeURIComponent(token)}&lang=${encodeURIComponent(locale)}`;
}

// ── Formatierung ─────────────────────────────────────────────
export function formatCurrency(amount, currency = 'EUR') {
  const locale = localStorage.getItem('locale') || 'de';
  return new Intl.NumberFormat(locale, { style: 'currency', currency }).format(amount || 0);
}

function parseDateValue(dateStr) {
  const value = String(dateStr || '').trim();
  if (!value) return null;

  // Reine Datumswerte immer lokal interpretieren, damit es keinen UTC-Tagesversatz gibt.
  if (/^\d{4}-\d{2}-\d{2}$/.test(value)) {
    return new Date(`${value}T00:00:00`);
  }

  return new Date(value);
}

export function formatDate(dateStr) {
  if (!dateStr) return '–';
  const locale = localStorage.getItem('locale') || 'de';
  return new Intl.DateTimeFormat(locale).format(parseDateValue(dateStr));
}

export function formatPercent(value, digits = 0) {
  const locale = localStorage.getItem('locale') || 'de';
  return new Intl.NumberFormat(locale, {
    style: 'percent',
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  }).format(Number(value || 0));
}

export function formatDateTime(dateStr) {
  if (!dateStr) return '–';
  const locale = localStorage.getItem('locale') || 'de';
  return new Intl.DateTimeFormat(locale, {
    day: '2-digit', month: '2-digit', year: 'numeric',
    hour: '2-digit', minute: '2-digit',
  }).format(parseDateValue(dateStr));
}
export function formatDuration(minutes) {
  const h = Math.floor(minutes / 60);
  const m = minutes % 60;
  return `${h}:${String(m).padStart(2, '0')} h`;
}

// ── Labels ────────────────────────────────────────────────────
export const STATUS_LABELS = {
  draft: 'Entwurf', sent: 'Versendet', accepted: 'Angenommen',
  rejected: 'Abgelehnt', invoiced: 'Berechnet', paid: 'Bezahlt',
  cancelled: 'Storniert', pending: 'Ausstehend',
};
export const DOC_TYPE_LABELS = { offer: 'Angebot', invoice: 'Rechnung' };
export const PROJECT_STATUS_LABELS = {
  lead: 'Lead', offer: 'Angebot', ordered: 'Beauftragt',
  in_progress: 'In Arbeit', completed: 'Abgeschlossen', cancelled: 'Abgebrochen',
};
export const PROJECT_STATUS_COLORS = {
  lead: 'muted', offer: 'info', ordered: 'warning',
  in_progress: 'accent', completed: 'success', cancelled: 'danger',
}

// ── Chat ─────────────────────────────────────────────────────
export const aufmassApi = {
  list:    (params)   => api.get('/aufmass', { params }),
  get:     (id)       => api.get(`/aufmass/${id}`),
  create:  (data)     => api.post('/aufmass', data),
  update:  (id, data) => api.put(`/aufmass/${id}`, data),
  approve: (id)       => api.post(`/aufmass/${id}/approve`),
  reopen:  (id)       => api.post(`/aufmass/${id}/reopen`),
  delete:  (id)       => api.delete(`/aufmass/${id}`),
};

export const chatApi = {
  rooms:    ()                    => api.get('/chat/rooms'),
  messages: (projectId)          => api.get(`/chat/${projectId}/messages`),
  send: (projectId, content, imageFile = null) => {
    if (imageFile) {
      const fd = new FormData();
      if (content) fd.append('content', content);
      fd.append('image', imageFile);
      return api.post(`/chat/${projectId}/messages`, fd, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
    }
    return api.post(`/chat/${projectId}/messages`, { content });
  },
  markSeen: (projectId)          => api.patch(`/chat/${projectId}/seen`),
};